import React, { useState, useEffect } from "react"
import { Formik, Field, Form, ErrorMessage } from "formik"
import { navigate } from "gatsby"
import * as Yup from "yup"
import axios from "axios"
import { getImage } from "gatsby-plugin-image"

import { Popup } from "../../../components/ContactForm/Popup"
import { SavorReasonLists } from "../../../components/ContactForm/savorReasonLists"

import placeholderImage from "../../../images/other1.jpg"

import "./index.css"
import './safari.css'
import { Tooltip } from "./tooltip"
import { RightContent } from "./rightContent"
import { LeftContent } from "./leftContent"
import { ContinuationPop } from "./continuationPop"

const ContactPage = ({ data }) => {
    const selectionData = [
        'Google or Search Engine Result',
        'Word of Mouth',
        'Shows and Events',
        'Ad on Social Media',
        'Facebook',
        'Linkedin',
        'Instagram',
        'Pinterest',
        'Reddit',
        'Mr. Coffee Bags'
    ];

    const services = data.contentfulPage.tooltip
    const [isLoading, setIsLoading] = useState(false);
    const [isBrowser, setIsBrowser] = useState(false);
    const [openAccordions, setOpenAccordions] = useState(new Array(services.length).fill(false));
    const [selectedData, setSelectedData] = useState([]);

    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [continuationPopActived, setContinuationPopActived] = useState(false)

    const openAccordion = (index) => {
        const updatedAccordions = [...openAccordions];
        updatedAccordions[index] = !updatedAccordions[index];
        setOpenAccordions(updatedAccordions);
    };

    let contentData = data.contentfulPage

    const heroBackground = contentData.pageMediaList !== null ? getImage(contentData.pageMediaList[0]) : placeholderImage;

    const backgroundStyle = {
        backgroundImage: contentData.pageMediaList !== null ? `url(${heroBackground.images.fallback.src})` : `url(${placeholderImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
    };

    useEffect(() => {
        const userAgent = navigator.userAgent;
        
        if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
            setIsBrowser('safari')
        } else if (userAgent.includes("Chrome")) {
            setIsBrowser('chrome')
        } else {
            setIsBrowser('chrome')
        }

        if (continuationPopActived) {
            document.documentElement.classList.add("html--menu-open");
          } else {
            document.documentElement.classList.remove("html--menu-open");
          }
      
          return () => {
            document.documentElement.classList.remove("html--menu-open");
          };
    }, [continuationPopActived])

    const handleSelect = async(item) => {
        try {
            setSelectedData((prevSelectedData) => {
                if (prevSelectedData.includes(item)) {
                    return prevSelectedData.filter(selectedItem => selectedItem !== item);
                }
                return [...prevSelectedData, item];
            });
    
            if (!selectedData.includes(item)) {
                const currentDate = new Date();
                const data = {
                    name: name,
                    email: email,
                    referralSource: item,
                    month: currentDate.toLocaleString('default', { month: 'long' })
                };

                const response = await axios.post('https://tj5fp7lfvi.execute-api.us-west-2.amazonaws.com/staging/saveData', data);
            }
        } catch (error) {
            console.error('Form submission failed:', error);
            alert('Form submission failed. Please try again.');
        }
    };

    return (
        <div className={`page-contact ${isBrowser}`} style={backgroundStyle}>
            {isLoading && <div className="loading"><div className="loader"></div></div>}
            <div className="container-custom">
                <Formik
                    initialValues={{ name: "", phoneNumber: "", email: "", message: "", company: "", location: "", checked: [], other:"", file: undefined  }}
                    validationSchema={Yup.object({
                        name: Yup.string().required("Required"),
                        phoneNumber: Yup.string().required("Required"),
                        message: Yup.string().required("Required"),
                        email: Yup.string().email("Invalid email address").required("Required"),
                        company: Yup.string().required("Required"),
                        location: Yup.string().required("Required"),
                        file: Yup.mixed()
                        .test("fileType", "Only PDF files are allowed", (value) => {
                        if (value && value.type) {
                            return value.type === "application/pdf";
                        }
                        return true; 
                        })
                        .test("fileSize", "File size should not surpass 15MB", (value) => {
                        if (value && value.size) {
                            return value.size <= 15 * 1024 * 1024; 
                        }
                        return true; 
                        }),
                    })}
                    onSubmit={async (values, { resetForm, setFieldValue }) => {
                        try {
                            setIsLoading(true);
                            setEmail(values.email)
                            setName(values.name)

                            let fileName = '';
                            if (values.file !== undefined) {
                                const currentTime = new Date();
                                const timestamp = currentTime.getTime();
                                const fileExtension = values.file.name.split('.').pop();
                                fileName = `${values.name}-attachment-${timestamp}.${fileExtension}`;
                                const formData = new FormData();
                                formData.append("file", values.file);

                                await axios.post(
                                    `https://7tm37lbce9.execute-api.us-west-1.amazonaws.com/develop/file-upload?fileName=${fileName}`,
                                    formData,
                                    {
                                        headers: {
                                            'Content-Type': 'multipart/form-data',
                                        }
                                    }
                                );
                            }
                            const requestData = {
                                name: values.name,
                                email: values.email,
                                bodyText: values.message,
                                phoneNumber: values.phoneNumber,
                                company: values.company,
                                location: values.location,
                                interestList: values.checked,
                                otherInterest: values.other,
                                fileName: values.file !== undefined ? fileName : '',
                            }
                            if(values.file !== undefined) {
                                const formData = new FormData();
                                formData.append("file", values.file);
    
                                await axios.post(
                                `https://7tm37lbce9.execute-api.us-west-1.amazonaws.com/develop/file-upload?fileName=${values.file.name}`,
                                formData,
                                {
                                    headers: {
                                    'Content-Type': 'multipart/form-data', 
                                    }
                                }
                                );
                            }
                            await axios.post("https://c83iqh8dmj.execute-api.us-west-2.amazonaws.com/develop/sendemail", requestData);
                            setFieldValue("file", null); 

                            const fileInput = document.getElementById("file");
                            if (fileInput) {
                                fileInput.value = "";   
                            }
                            if(data.contentfulPage.pageLanguage !== null) {
                                navigate('/es/gracias/');
                            } else navigate('/thank-you/')
                            resetForm();
                            setIsLoading(false);
                        } catch (error) {
                            alert("Form submission failed. Please try again.");
                        }
                    }}
                >
                    {({setFieldValue, values, errors, touched, handleChange, handleSubmit, setFieldTouched}) => (
                        <Form>
                            <div className="grid col-3-6 col-1-lg gap-71 page-contact__form">
                                <RightContent pageContent={data.contentfulPage} />
                                <LeftContent 
                                    openAccordion={openAccordion} 
                                    openAccordions={openAccordions} 
                                    pageContentForm={data.contentfulPage} 
                                    values={values} 
                                    setFieldValue={setFieldValue} 
                                    errors={errors} 
                                    touched={touched} 
                                    setEmail={setEmail}
                                    setContinuationPopActived={setContinuationPopActived}
                                    setFieldTouched={setFieldTouched} />
                            </div>
                            <ContinuationPop 
                                continuationPopActived={continuationPopActived} 
                                selectionData={selectionData} 
                                selectedData={selectedData}
                                handleSelect={handleSelect} />
                            <Popup/>
                        </Form>
                    )}
                </Formik>
            </div>
            
        </div>
    );
};

export default ContactPage